export const enAutoRepliesTranslations = {
    AUTO_REPLIES__PAGE_HEADER: 'Auto-replies to reviews',
    AUTO_REPLIES__ADD_RULE: 'Add Rule',
    AUTO_REPLIES__TOTAL_AUTO_REPLIES_LEFT: 'Total auto responses left: {autoRepliesLeft}',
    AUTO_REPLIES__LIST_OF_RULES: 'List of rules',
    AUTO_REPLIES__TABLE__TITLE: 'Title',
    AUTO_REPLIES__TABLE__TYPE: 'Type',
    AUTO_REPLIES__TABLE__REPLY: 'Reply',
    AUTO_REPLIES__TABLE__CONDITION: 'Condition',
    AUTO_REPLIES__REPLY_TYPE__TEMPORARY: 'Temporary',
    AUTO_REPLIES__REPLY_TYPE__PERMANENT: 'Permanent',
    AUTO_REPLIES__TABLE__ACTIONS: 'Actions',
    AUTO_REPLIES__TABLE__VALIDITY: 'Validity',

    AUTO_REPLIES__REMOVING_A_RULE: 'Rule removing',
    AUTO_REPLIES__THE_RULE_RULE_NAME_WILL_BE_REMOVED_CONFIRM: 'The rule(s) "{ruleNames}" will be removed. Confirm?',
    AUTO_REPLIES__HEADER__RULE_CREATION: 'Rule creating',
    AUTO_REPLIES__HEADER__EDITING_A_RULE: 'Rule editing',
    AUTO_REPLIES__HEADER__SUBHEADER__INFO: 'You can read more about setting up auto-replies in our {articleLink}.',
    AUTO_REPLIES__HEADER__SUBHEADER__INFO_SITE: 'article',

    AUTO_REPLIES__NOTIFICATION__ERROR_CREATE: 'Auto response creating error',
    AUTO_REPLIES__NOTIFICATION__SUCCESS_CREATE: 'Auto reply created successfully',
    AUTO_REPLIES__NOTIFICATION__ERROR_UPDATE: 'Auto reply update error',
    AUTO_REPLIES__NOTIFICATION__SUCCESS_UPDATE: 'Auto reply updated successfully',
    AUTO_REPLIES__NOTIFICATION__ERROR_DELETE: 'Auto-response deleting error',
    AUTO_REPLIES__NOTIFICATION__SUCCESS_DELETE: 'Auto reply deleted successfully',
    AUTO_REPLIES__NOTIFICATION__ERROR_CONFLICT_IDS: 'Rules: {ruleNames}',

    AUTO_REPLIES__FORM__DELETE_RULE: 'Delete rule',
    AUTO_REPLIES__FORM__CONTROL: 'Control',
    AUTO_REPLIES__FORM__ENABLE_THE_RULE: 'Enable the rule',
    AUTO_REPLIES__FORM__TEST_MODE: 'Test mode',
    AUTO_REPLIES__FORM__TEST_MODE__POPOVER_TEXT:
        'The reviews page will display auto-reply suggestions. This way you can make sure the settings are correct.',
    AUTO_REPLIES__FORM__BASIC_INFORMATION: 'Basic information',
    AUTO_REPLIES__FORM__TITLE: 'Title',
    AUTO_REPLIES__FORM__ENTER_A_NAME_FOR_THE_RULE: 'Enter a name for the rule',
    AUTO_REPLIES__FORM__DESCRIPTION: 'Description',
    AUTO_REPLIES__FORM__ENTER_A_DESCRIPTION: 'Enter a description',

    AUTO_REPLIES__FORM__FILTERS: 'Filters',
    AUTO_REPLIES__FORM__REVIEW_TARGET: 'Review type',
    AUTO_REPLIES__FORM__REVIEW_TARGET__COMPANY: 'Company',
    AUTO_REPLIES__FORM__REVIEW_TARGET__STORES: 'App stores',
    AUTO_REPLIES__FORM__APPLICATIONS: 'Applications',
    AUTO_REPLIES__FORM__SELECT_APPLICATIONS: 'Select applications',
    AUTO_REPLIES__FORM__COMPANIES: 'Companies',
    AUTO_REPLIES__FORM__FEEDBACK_SOURCE: 'Feedback source',
    AUTO_REPLIES__FORM__SELECTED: 'Selected: {count}',
    AUTO_REPLIES__FORM__SELECT_SOURCES: 'Select sources',
    AUTO_REPLIES__FORM__RATING: 'Rating',
    AUTO_REPLIES__FORM__CONTENT_OF_REVIEWS: 'Content of reviews',
    AUTO_REPLIES__FORM__ATTACHMENTS: 'Attachments',
    AUTO_REPLIES__FORM__ATTACHMENTS__PLACEHOLDER: 'Select',
    AUTO_REPLIES__FORM__ATTACHMENTS__WITH: 'With attachments',
    AUTO_REPLIES__FORM__ATTACHMENTS__WITHOUT: 'Without attachments',
    AUTO_REPLIES__FORM__KEYWORDS: 'Keywords',
    AUTO_REPLIES__FORM__KEYWORDS__CONTAINS: 'Contains',
    AUTO_REPLIES__FORM__KEYWORDS__NOT_CONTAINS: 'Does not contain',
    AUTO_REPLIES__FORM__KEYWORDS__PLACEHOLDER: 'Enter words and press Enter',
    AUTO_REPLIES__FORM__KEYWORDS__ADD: 'Add a keyword condition',
    AUTO_REPLIES__FORM__AUTO_TAGS: 'Auto-tags',
    AUTO_REPLIES__FORM__AUTO_TAGS__PLACEHOLDER: 'Select auto-tags',
    AUTO_REPLIES__FORM__ALL_REVIEWS: 'All reviews',
    AUTO_REPLIES__FORM__REVIEWS_WITH_TEXT: 'Reviews with text',
    AUTO_REPLIES__FORM__REVIEWS_WITHOUT_TEXT: 'Reviews without text',
    AUTO_REPLIES__FORM__TIME_TO_RECEIVE_FEEDBACK: 'Time to receive feedback',
    AUTO_REPLIES__FORM__TIMEZONE: 'Timezone',
    AUTO_REPLIES__FORM__RESPONSE_TEMPLATES: 'Response templates',
    AUTO_REPLIES__FORM__SELECT_TEMPLATES: 'Select templates',
    AUTO_REPLIES__FORM__THE_ORDER_OF_CHOOSING_A_TEMPLATE: 'The order of choosing a template',
    AUTO_REPLIES__FORM__RANDOM: 'Random',
    AUTO_REPLIES__FORM__CONSISTENTLY: 'Consistently',
    AUTO_REPLIES__FORM__SCHEDULE: 'Schedule',
    AUTO_REPLIES__FORM__TEMPORARY: 'Temporary',
    AUTO_REPLIES__FORM__INFINITE_RANGE: 'Infinite validity',
    AUTO_REPLIES__FORM__DAYS_OF_THE_WEEK: 'Days of the week',
    AUTO_REPLIES__FORM__SELECT_THE_DAYS_OF_THE_WEEK: 'Select days of the week',
    AUTO_REPLIES__FORM__DATE_PERIOD: 'Date period',
    AUTO_REPLIES__FORM__FOR_DATES: 'For dates',
    AUTO_REPLIES__FORM__ERROR: 'Please fill in all required fields',
    AUTO_REPLIES__FORM__REPLY_TYPE: 'Reply type',
    AUTO_REPLIES__FORM__REPLY_TYPE__NEURALLINK: 'Neural network',
    AUTO_REPLIES__FORM__METHOD_OF_SENDING__PLACEHOLDER: 'Select sending method',
    AUTO_REPLIES__FORM__METHOD_OF_SENDING__LABEL: 'Auto-reply sending method',
    AUTO_REPLIES__FORM__REPLY_TYPE__TEMPLATE: 'Template',
    AUTO_REPLIES__TABLE__EMPTY__TITLE: 'No auto-reply rules created',
    AUTO_REPLIES__TABLE__EMPTY__DESCRIPTION: 'Create an auto-reply rule using templates or a neural network.',
    AUTO_REPLIES__FORM__ADDITIONAL_INFO__SELECT_METHOD: 'Select how the auto-replies should be sent:',
    AUTO_REPLIES__FORM__ADDITIONAL_INFO__AUTOMATED:
        'Automatically — replies will be sent immediately without manual review.',
    AUTO_REPLIES__FORM__ADDITIONAL_INFO__MANUAL:
        'With manual approval — suggested auto-replies will appear on the review page and can be checked before sending.',

    AUTO_REPLIES__POPUP__RESPONSE_TEMPLATES: 'Response templates',
    AUTO_REPLIES__POPUP__SEARCH_FOR_TEMPLATES: 'Search for templates',
    AUTO_REPLIES__POPUP__ALL_GROUPS: 'All groups',
    AUTO_REPLIES__POPUP__UPDATE_TEMPLATES: 'Update templates list',
    AUTO_REPLIES__POPUP__GO_TO_TEMPLATE_SETTINGS: 'Template settings',
    AUTO_REPLIES__POPUP__PRIVATE_TEMPLATE_TOOLTIP__TITLE: 'Private Template',
    AUTO_REPLIES__POPUP__PRIVATE_TEMPLATE_TOOLTIP__TEXT:
        'The private template cannot be used in auto-response rules. Create a new one or change access to the command one in {articleLink}.',
    AUTO_REPLIES__POPUP__PRIVATE_TEMPLATE_TOOLTIP__TEXT_LINK: 'Template settings',
    AUTO_REPLIES__FORM__AUTO_SENDING: 'Automatic sending',
    AUTO_REPLIES__FORM__MANUAL_CONFIRMATION: 'Manual confirmation',
};
